import React from "react";

/* ── Asset imports ── */
import HeroBgImg         from "../../asset/images/news/AcusensusTextingDrivingHero-bg.webp";
import YoutubeIcon       from "../../asset/images/news/icon-youtube.svg";
import LinkedinIcon      from "../../asset/images/news/icon-linkedin.svg";
import BcSepIcon         from "../../asset/images/news/breadcrumb-separator.svg";
import ProfileIcon       from "../../asset/images/news/icon-profile.svg";
import CalendarIcon      from "../../asset/images/news/icon-calendar.svg";
import ClockIconImg      from "../../asset/images/news/icon-clock.svg";
import CommentsIcon      from "../../asset/images/news/icon-comments.svg";
import PreviousIcon      from "../../asset/images/news/icon-previous.svg";
import NextIcon          from "../../asset/images/news/icon-next.svg";
import FacebookIcon      from "../../asset/images/news/icon-facebook.svg";
import TwitterIcon       from "../../asset/images/news/icon-twitter.svg";
import LinkedinShareIcon from "../../asset/images/news/icon-linkedin-share.svg";

/* ── Recent post thumbnails ── */
import RecentImg1 from "../../asset/images/news/news-1.webp";
import RecentImg2 from "../../asset/images/news/news-2.webp";
import RecentImg3 from "../../asset/images/news/news-3.webp";
import RecentImg4 from "../../asset/images/news/news-4.webp";

const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700;800&display=swap');

  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
  .atxd { font-family: 'Poppins', sans-serif; font-size: 14px; color: #202020; background: #fff; }

  /* ══ HERO ══ */
  .atxd-hero {
    position: relative; width: 100%; height: 460px;
    overflow: hidden;
  }
  .atxd-hero-bg {
    position: absolute; inset: 0;
    width: 100%; height: 100%;
    object-fit: cover; object-position: center right; display: block;
  }
  .atxd-hero-overlay {
    position: absolute; inset: 0;
    // background: linear-gradient(
    //   to right,
    //   rgba(0,0,0,0.85) 0%,
    //   rgba(0,0,0,0.65) 38%,
    //   rgba(0,0,0,0.10) 100%
    // );
  }
  .atxd-hero-content {
    position: absolute; inset: 0;
    display: flex; flex-direction: column; justify-content: center;
    padding: 0 102px;
    max-width: 1600px; margin: 0 auto; left: 0; right: 0;
  }
  .atxd-hero-title {
    font-family: 'Poppins', sans-serif;
    font-size: 42px; font-weight: 600; color: #fff;
    line-height: 120%; margin-bottom: 15px; max-width: 575px;
  }
  .atxd-hero-divider {
    width: 575px; height: 2px;
    background: #EB2019; border: none; margin-bottom: 15px;
  }
  .atxd-hero-subtitle {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #fff;
    line-height: 160%; max-width: 479px;
  }

  /* ══ BREADCRUMB ══ */
  .atxd-breadcrumb { width: 100%; padding: 40px 0 0 0; }
  .atxd-breadcrumb-inner {
    max-width: 1600px; margin: 0 auto; padding: 0 102px;
    display: flex; align-items: center; flex-wrap: wrap;
  }
  .atxd-bc-item {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 500; color: #202020;
    text-decoration: none; display: flex; align-items: center; gap: 14px;
    transition: color 0.15s;
  }
  .atxd-bc-item:hover { color: #EB2019; }
  .atxd-bc-sep {
    display: flex; align-items: center; justify-content: center;
    width: 24px; height: 24px; border-radius: 50%;
    margin: 0 8px; flex-shrink: 0;
  }
  .atxd-bc-sep img { width: 24px; height: 24px; display: block; }
  .atxd-bc-item.active { color: #202020; font-weight: 500; }

  /* ══ INNER ══ */
  .atxd-inner { max-width: 1600px; margin: 0 auto; padding: 0 102px; }

  /* ══ MAIN ══ */
  .atxd-main-section { padding: 80px 0 120px 0; }
  .atxd-main-row { display: flex; align-items: flex-start; gap: 89px; }

  /* ══ ARTICLE ══ */
  .atxd-article { flex: 1; min-width: 0; }

  .atxd-meta-bar {
    display: flex; align-items: center; flex-wrap: wrap; gap: 20px;
    margin-bottom: 30px;
  }
  .atxd-meta-item {
    display: flex; align-items: center; gap: 8px;
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #202020;
    border-right: 1px solid #7A7A7A; padding-right: 15px;
  }
  .atxd-meta-item:last-child { border-right: none; padding-right: 0; }
  .atxd-meta-item img { width: 24px; height: 24px; display: block; flex-shrink: 0; }

  .atxd-article-title {
    font-family: 'Poppins', sans-serif;
    font-size: 32px; font-weight: 600; color: #202020;
    line-height: 140%; margin-bottom: 30px;
  }

  .atxd-article-body {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #202020;
    line-height: 160%;
  }
  .atxd-article-body p { margin-bottom: 20px; }
  .atxd-article-body p:last-child { margin-bottom: 0; }

  /* Red left-border blockquote */
  .atxd-blockquote {
    border-left: 4px solid #EB2019;
    padding-left: 16px;
    margin-bottom: 20px;
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #202020;
    line-height: 160%;
  }

  .atxd-article-body strong { font-weight: 600; color: #202020; }

  .atxd-red-link-plain { color: #EB2019; text-decoration: underline; font-weight: 600; }
  .atxd-red-link-plain:hover { opacity: 0.8; }

  /* ══ BOTTOM ROW ══ */
  .atxd-bottom-row {
    display: flex; align-items: center; justify-content: space-between;
    margin-top: 30px; padding-top: 30px;
    border-top: 1px solid #C7C7C7; flex-wrap: wrap; gap: 16px;
  }
  .atxd-bottom-nav { display: flex; align-items: center; gap: 60px; }
  .atxd-nav-btn {
    display: inline-flex; align-items: center; gap: 20px;
    font-family: 'Poppins', sans-serif;
    font-size: 20px; font-weight: 500; color: #202020;
    text-decoration: none; background: none; border: none;
    cursor: pointer; transition: color 0.15s;
  }
  .atxd-nav-btn:hover { color: #EB2019; }
  .atxd-nav-btn img { width: 40px; height: 40px; display: block; }

  .atxd-share-icons { display: flex; align-items: center; gap: 20px; }
  .atxd-share-icon {
    display: flex; align-items: center; justify-content: center;
    width: 40px; height: 40px; border-radius: 50%;
    text-decoration: none; flex-shrink: 0; transition: opacity 0.15s;
  }
  .atxd-share-icon:hover { opacity: 0.85; }
  .atxd-share-icon img { width: 44px; height: 44px; display: block; }

  /* ══ SIDEBAR ══ */
  .atxd-sidebar { flex: 0 0 475px; }
  .atxd-sidebar-block { margin-bottom: 60px; }
  .atxd-sidebar-title {
    font-family: 'Poppins', sans-serif;
    font-size: 24px; font-weight: 600; color: #202020;
    margin-bottom: 30px; padding-bottom: 20px;
    border-bottom: 1px solid #EB2019; line-height: 120%;
  }
  .atxd-recent-list { display: flex; flex-direction: column; gap: 30px; }
  .atxd-recent-item {
    display: flex; align-items: flex-start; gap: 12px;
    text-decoration: none; color: #202020;
  }
  .atxd-recent-item:hover .atxd-recent-title { color: #EB2019; }
  .atxd-recent-img {
    flex: 0 0 200px; height: 120px;
    object-fit: cover; border-radius: 6px; display: block;
  }
  .atxd-recent-body { flex: 1; min-width: 0; }
  .atxd-recent-title {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #202020;
    line-height: 160%; transition: color 0.15s;
    display: -webkit-box; -webkit-line-clamp: 3;
    -webkit-box-orient: vertical; overflow: hidden;
  }
  .atxd-social-icons { display: flex; align-items: center; gap: 30px; }
  .atxd-social-icon {
    display: flex; align-items: center; justify-content: center;
    width: 40px; height: 40px; border-radius: 6px; overflow: hidden;
    text-decoration: none; transition: opacity 0.15s;
  }
  .atxd-social-icon:hover { opacity: 0.8; }
  .atxd-social-icon img { width: 44px; height: 44px; object-fit: contain; display: block; }

  /* ══ RESPONSIVE — TABLET ══ */
  @media (max-width: 768px) {
    .atxd-hero             { height: 350px; }
    .atxd-hero-content     { padding: 0 32px; }
    .atxd-hero-title       { font-size: 30px; }
    .atxd-hero-divider     { width: 100%; max-width: 575px; }
    .atxd-breadcrumb       { padding: 24px 0 0 0; }
    .atxd-breadcrumb-inner { padding: 0 32px; }
    .atxd-inner            { padding: 0 32px; }
    .atxd-main-section     { padding: 48px 0 60px 0; }
    .atxd-main-row         { flex-direction: column; gap: 48px; }
    .atxd-sidebar          { flex: none; width: 100%; }
    .atxd-article-title    { font-size: 20px; }
  }

  /* ══ RESPONSIVE — MOBILE ══ */
  @media (max-width: 480px) {
    .atxd-hero             { height: 360px; }
    .atxd-hero-content     { padding: 0 16px; }
    .atxd-hero-title       { font-size: 24px; margin-bottom: 15px; }
    .atxd-hero-divider     { width: 100%; }
    .atxd-hero-subtitle    { font-size: 14px; }
    .atxd-breadcrumb       { padding: 30px 0 0 0; }
    .atxd-breadcrumb-inner { padding: 0 16px; }
    .atxd-bc-item          { font-size: 14px; gap: 14px; }
    .atxd-bc-sep           { width: 18px; height: 18px; margin: 0 4px; }
    .atxd-bc-sep img       { width: 22px; height: 22px; }
    .atxd-inner            { padding: 0 16px; }
    .atxd-main-section     { padding: 30px 0 60px 0; }
    .atxd-main-row         { flex-direction: column; gap: 60px; }
    .atxd-sidebar          { flex: none; width: 100%; }
    .atxd-article-title    { font-size: 20px; margin-bottom: 15px; }
    .atxd-article-body     { font-size: 14px; }
    .atxd-article-body p   { margin-bottom: 15px; }
    .atxd-blockquote       { font-size: 14px; margin-bottom: 15px; }
    .atxd-article-body strong { font-size: 16px; }
    .atxd-meta-item        { font-size: 14px; }
    .atxd-meta-item:nth-child(3) { border-right: none; padding-right: 0; }
    .atxd-nav-btn img      { width: 24px; height: 24px; }
    .atxd-nav-btn          { font-size: 14px; }
    .atxd-share-icon img   { width: 34px; height: 34px; }
    .atxd-sidebar-title    { font-size: 20px; }
    .atxd-bottom-nav       { gap: 20px; }
  }
`;

const recentPosts = [
  {
      img: RecentImg1,
      title: "Battery Formation & Testing: Enabling The Rise Of EV & Energy Storage Manufacturing",
      slug: "battery-formation-testing-enabling-the-rise-of-ev-energy-storage-manufacturing/",
    },
    {
      img: RecentImg2,
      title: "Next-Gen ESP Power Supplies: Upgrades and Sustainability in Industrial Air Pollution Control",
      slug: "next-gen-esp-power-supplies-upgrades-and-sustainability-in-industrial-air-pollution-control/",
    },
    {
      img: RecentImg3,
      title: "Green Hydrogen Power Electronics: Ador Powertron at the Forefront of Electrolyzer Rectifier Setups",
      slug: "green-hydrogen-power-electronics-ador-powertron-at-the-forefront-of-electrolyzer-rectifier-setups/",
    },
    {
      img: RecentImg4,
      title: "Transformer Bushings: Types & Importance",
      slug: "transformer-bushings-guide/",
    },
];

export default function AcusensusTextingDriving() {
  return (
    <div className="atxd">
      <style>{CSS}</style>

      {/* ══ HERO ══ */}
      <section className="atxd-hero">
        <img className="atxd-hero-bg" src={HeroBgImg} alt="Soon drivers in Australia won't be able to get away with texting and driving Hero" />
        <div className="atxd-hero-overlay" />
        <div className="atxd-hero-content">
          <h1 className="atxd-hero-title">
            Soon drivers in Australia won't be able to get away with texting and driving, thanks to Acusensus technology.
          </h1>
          <hr className="atxd-hero-divider" />
          <p className="atxd-hero-subtitle">
            Everything we do is designed, whether we're producing a magazine, a website, or a bridge. Design is really the creative invention that designs everything.
          </p>
        </div>
      </section>

      {/* ══ BREADCRUMB ══ */}
      <nav className="atxd-breadcrumb" aria-label="Breadcrumb">
        <div className="atxd-breadcrumb-inner">
          <a href="/" className="atxd-bc-item">Home</a>
          <span className="atxd-bc-sep"><img src={BcSepIcon} alt="" /></span>
          <a href="/news" className="atxd-bc-item">News &amp; Updates</a>
          <span className="atxd-bc-sep"><img src={BcSepIcon} alt="" /></span>
          <span className="atxd-bc-item active">Post</span>
        </div>
      </nav>

      {/* ══ MAIN ══ */}
      <section className="atxd-main-section">
        <div className="atxd-inner">
          <div className="atxd-main-row">

            {/* ── ARTICLE ── */}
            <article className="atxd-article">

              {/* Meta bar */}
              <div className="atxd-meta-bar">
                <span className="atxd-meta-item"><img src={ProfileIcon} alt="author" /> Admin</span>
                <span className="atxd-meta-item"><img src={CalendarIcon} alt="date" /> March 26, 2024</span>
                <span className="atxd-meta-item"><img src={ClockIconImg} alt="time" /> 11:02 am</span>
                <span className="atxd-meta-item"><img src={CommentsIcon} alt="comments" /> No Comments</span>
              </div>

              {/* Title */}
              <h1 className="atxd-article-title">
                Soon drivers in Australia won't be able to get away with texting and driving, thanks to Acusensus technology.
              </h1>

              {/* Body */}
              <div className="atxd-article-body">

                <blockquote className="atxd-blockquote">
                  Ador recently announced an investment in Australian traffic and safety enforcement specialist Acusensus Pty Ltd, taking a majority equity position in the company. Acusensus specialises on the use of radar, cameras and software for unique path breaking innovative solutions to identify and create infringements for driving whilst distracted, such as texting or using an electronic device whilst driving, seat belt usage, and other related traffic safety offences.
                </blockquote>

                <p>Thousands of motorists are being caught using their phones while driving every day and there is a disturbing reason why people think they can get away with it.</p>

                <p>Compared to speeding and drink driving, mobile phone distraction is a "major unaddressed source of road trauma".</p>

                <p>Campaigns warning about the dangers of phone use have ramped up in recent years, with the NSW Government even increasing the penalty for using a phone while driving from four demerit points to five.</p>

                <p>The lack of a technological solution to this issue may be the reason drivers continue to break this rule so frequently.</p>

                <p>Speed cameras and roadside drug and alcohol tests are a deterrent for many drivers, but until now there hasn't really been technology specifically designed to catch distracted motorists.</p>

                <p>Read the full <a href="https://www.news.com.au/technology/motoring/on-the-road/man-behind-phone-detection-cameras-reveals-why-people-text-and-drive/news-story/df57f7653cbf710a8f3356ed3902a575" className="atxd-red-link-plain" target="blank">Report in news.com.au:</a></p>

                <p>Ador recently announced an investment in Australian traffic and safety enforcement specialist Acusensus Pty Ltd, taking a majority equity position in the company. Acusensus specialises on the use of radar, cameras and software for unique path breaking innovative solutions to identify and create infringements for driving whilst distracted, such as texting or using an electronic device whilst driving, seat belt usage, and other related traffic safety offences.</p>

              </div>

              {/* ── Bottom row ── */}
              <div className="atxd-bottom-row">
                <div className="atxd-bottom-nav">
                  <a href="/news/ador-equity-traffic-safety" className="atxd-nav-btn">
                    <img src={PreviousIcon} alt="Previous" />
                    Previous
                  </a>
                  <a href="/news/motorists-mobile-phone-driving" className="atxd-nav-btn">
                    Next
                    <img src={NextIcon} alt="Next" />
                  </a>
                </div>
                <div className="atxd-share-icons">
                  <a href="https://www.facebook.com/sharer.php?u=https://adorpowertron.com/soon-drivers-in-australia-wont-be-able-to-get-away-with-texting-and-driving-thanks-to-acusensus-technology/" className="atxd-share-icon" aria-label="Facebook" target="blank">
                    <img src={FacebookIcon} alt="Facebook" />
                  </a>
                  <a href="https://x.com/i/jf/onboarding/web?redirect_after_login=%2Fintent%2Ftweet%3Ftext%3DAdor%2520recently%2520announced%2520an%2520investment%2520in%2520Australian%2520traffic%2520and%2520safety%2520enforcement%2520specialist%2520Acusensus%2520Pty%2520Ltd%2C%2520taking%2520a%2520majority%2520equity%2520position%2520in%2520the%2520company.%2520Acusensus%2520specialises%2520on%2520the%2520use%2520of%2520radar%2C%2520cameras%2520and%2520software%2520for%2520unique%2520path%2520breaking%2520innovative%2520solutions%2520to%2520identify%2520and%2520create%2520infringements%2520for%2520driving%2520whilst%2520distracted%2C%2520such%2520as%2520texting%2520or%2520using%2520an%2520electronic%2520device%2520whilst%2520driving%2C%2520seat%2520belt%2520usage%2C%2520and%2520other%2520related%2520traffic%2520safety%2520offences.%2520https%3A%2F%2Fadorpowertron.com%2Fsoon-drivers-in-australia-wont-be-able-to-get-away-with-texting-and-driving-thanks-to-acusensus-technology%2F&mode=login" className="atxd-share-icon" aria-label="Twitter" target="blank">
                    <img src={TwitterIcon} alt="Twitter" />
                  </a>
                  <a href="https://www.linkedin.com/uas/login?session_redirect=https%3A%2F%2Fwww.linkedin.com%2FshareArticle%3Fmini%3Dtrue%26url%3Dhttps%3A%2F%2Fadorpowertron.com%2Fsoon-drivers-in-australia-wont-be-able-to-get-away-with-texting-and-driving-thanks-to-acusensus-technology%2F%26title%3DAcusensus%2520tech%2520to%2520curb%2520texting%2520and%2520driving%2520in%2520Australia%2520%257C%2520Ador%26summary%3DAdor%2520recently%2520announced%2520an%2520investment%2520in%2520Australian%2520traffic%2520and%2520safety%2520enforcement%2520specialist%2520Acusensus%2520Pty%2520Ltd%2C%2520taking%2520a%2520majority%2520equity%2520position%2520in%2520the%2520company.%2520Acusensus%2520specialises%2520on%2520the%2520use%2520of%2520radar%2C%2520cameras%2520and%2520software%2520for%2520unique%2520path%2520breaking%2520innovative%2520solutions%2520to%2520identify%2520and%2520create%2520infringements%2520for%2520driving%2520whilst%2520distracted%2C%2520such%2520as%2520texting%2520or%2520using%2520an%2520electronic%2520device%2520whilst%2520driving%2C%2520seat%2520belt%2520usage%2C%2520and%2520other%2520related%2520traffic%2520safety%2520offences.%26source%3Dhttps%3A%2F%2Fadorpowertron.com%2Fsoon-drivers-in-australia-wont-be-able-to-get-away-with-texting-and-driving-thanks-to-acusensus-technology%2F" className="atxd-share-icon" aria-label="LinkedIn" target="blank">
                    <img src={LinkedinShareIcon} alt="LinkedIn" />
                  </a>
                </div>
              </div>

            </article>

            {/* ── SIDEBAR ── */}
            <aside className="atxd-sidebar">

              {/* Recent Posts */}
              <div className="atxd-sidebar-block">
                <p className="atxd-sidebar-title">Recent Posts</p>
                <div className="atxd-recent-list">
                  {recentPosts.map((post, idx) => (
                    <a key={idx} href={`/news/${post.slug}`} className="atxd-recent-item">
                      <img src={post.img} alt={post.title} className="atxd-recent-img" />
                      <div className="atxd-recent-body">
                        <span className="atxd-recent-title">{post.title}</span>
                      </div>
                    </a>
                  ))}
                </div>
              </div>

              {/* Social Media */}
              <div className="atxd-sidebar-block">
                <p className="atxd-sidebar-title">Social Media</p>
                <div className="atxd-social-icons">
                  <a href="https://www.youtube.com/@adorIndia" className="atxd-social-icon" aria-label="YouTube" target="blank">
                    <img src={YoutubeIcon} alt="YouTube" />
                  </a>
                  <a href="https://www.linkedin.com/uas/login?session_redirect=https%3A%2F%2Fwww.linkedin.com%2Fcompany%2F139191%2Fadmin%2F" className="atxd-social-icon" aria-label="LinkedIn" target="blank">
                    <img src={LinkedinIcon} alt="LinkedIn" />
                  </a>
                </div>
              </div>

            </aside>

          </div>
        </div>
      </section>

    </div>
  );
}